export enum VirtualizedTableTestIds {
  ROW_PREFIX = 'virtualized-table-row-',
  ACTION_BUTTON = 'virtualized-table-action-button',
  COLUMN_PREFIX = 'virtualized-table-column-',
  COLUMN_FOOTER_SUFFIX = '-footer',
}
